import requestv2 from "~/utils/http-v2";

const ruleApi = {
	getsGroup : async (params) => {
		const url = 'v2/rule/group';
		return await requestv2.get(url, {params});
	},
	addGroup : async (params) => {
		const url = 'v2/rule/group';
		return await requestv2.post(url, params);
	},
	updateGroup : async (params) => {
		const url = `v2/rule/group/${params.id}`;
		return await requestv2.patch(url, params);
	},
	deleteGroup : async (id) => {
		const url = `v2/rule/group/${id}`;
		return await requestv2.delete(url);
	},

	countItem : async (params) =>
	{
		const url = 'v2/rule/count';
		return await requestv2.get(url, {params});
	},
	getsItem : async (params) =>
	{
		const url = 'v2/rule';
		return await requestv2.get(url, {params});
	},
	addItem : async (params) =>
	{
		const url = 'v2/rule';
		return await requestv2.post(url, params);
	},
	updateItem : async (params) =>
	{
		const url = `v2/rule/${params.id}`;
		return await requestv2.patch(url, params);
	},
	deleteItem : async (id) =>
	{
		const url = `v2/rule/${id}`;
		return await requestv2.delete(url);
	},
};

export default ruleApi;